import { createContainer } from 'react-sweet-state';

import {
  ACTIONS,
  type Actions,
  type ContainerProps,
  PRIVATE_ACTIONS,
  type State,
  Store,
} from './Store';

export const StoreContainer = createContainer<State, Actions, ContainerProps>(Store, {
  onInit:
    () =>
    ({ dispatch }) => {
      dispatch(PRIVATE_ACTIONS.init());
      dispatch(ACTIONS.loadProject());
    },
});
